module.exports = __webpack_public_path__ + "img/產品資訊_產品單圖-08_2023.051b2491.png";